import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class MensagemProvider {
  baseUrl = environment.API_URL;

  counterMsgNaoLida = 0;

  constructor(public http: HttpClient) {}

  getMensagens(filtro, pag) {
    let params = new HttpParams()
      .set('expand', 'mensagemBasic, entidade')
      .set('page', pag.currentPage)
      .set('per-page', '20')
      .set('q', filtro.q);

    return this.http
      .get<any>(this.baseUrl + '/mensagem', {
        observe: 'response',
        params: params,
      })
      .map((data) => {
        this.counterMsgNaoLida = parseInt(data.headers.get('X-Count-Msg-Nao-Lida'));
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          mensagens: data.body,
          pagination: pag,
          //naoLidas: data.headers.get('X-Count-Msg-Nao-Lida')
        };
      });
  }

  getMensagem(id) {
    let params = new HttpParams().set('expand', 'links,criador,perguntas,respondida,exibirResultado');

    return this.http
      .get<any>(this.baseUrl + '/mensagem/' + id, {
        observe: 'response',
        params: params,
      })
      .map((data) => {
        this.counterMsgNaoLida = parseInt(data.headers.get('X-Count-Msg-Nao-Lida'));
        return {
          mensagem: data.body,
          //naoLidas: data.headers.get('X-Count-Msg-Nao-Lida')
        };
      });
  }

  getInicioMensagens() {
    return this.http.get<any>(this.baseUrl + '/mensagem/nao-lidas').map((data) => {
      if (!data.error) {
        this.counterMsgNaoLida = data;
        return data;
      } else {
        return false;
      }
    });
  }

  getTotalMensagensNaoLidas() {
    return this.counterMsgNaoLida;
  }

  excluir(idsList) {
    return this.http
      .post<any>(this.baseUrl + '/mensagem/excluir', { ids: idsList }, { observe: 'response' })
      .map((data) => {
        this.counterMsgNaoLida = parseInt(data.headers.get('X-Count-Msg-Nao-Lida'));
        return {
          status: data.body,
        };
      });
  }

  excluirCaixa() {
    return this.http.post<any>(this.baseUrl + '/mensagem/excluir-caixa', {}, { observe: 'response' }).map((data) => {
      this.counterMsgNaoLida = parseInt(data.headers.get('X-Count-Msg-Nao-Lida'));
      return {
        status: data.body,
      };
    });
  }

  criarMensagem(mensagem) {
    return this.http.post<any>(this.baseUrl + '/mensagem', mensagem).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/mensagem/mensagem.ts